import { createPortal } from 'react-dom';
import FlameIcon from './FlameIcon';
import { getLevelColor } from './useLevelLadder';
import {
	LevelUpBlurb,
	LevelUpCta,
	LevelUpEyebrow,
	LevelUpFooter,
	LevelUpHero,
	LevelUpMinis,
	LevelUpModal,
	LevelUpName,
	LevelUpStars,
	LevelUpTitle,
	TemperatureBackdrop,
	TemperatureClose,
} from './chatSelectedProfile.styles';

const LevelUpDialog = ({
	t,
	celebratedLevel,
	celebratedColor,
	celebratedLitCount,
	flameLevels,
	flameCount,
	levelDescription,
	onClose,
}) =>
	createPortal(
		<TemperatureBackdrop role="presentation" onClick={onClose}>
			<LevelUpModal
				role="dialog"
				aria-modal="true"
				aria-labelledby="levelup-title"
				onClick={(event) => event.stopPropagation()}
				$color={celebratedColor}
			>
				<LevelUpStars aria-hidden="true" $color={celebratedColor} />
				<TemperatureClose
					type="button"
					onClick={onClose}
					aria-label={t.close}
					$color={celebratedColor}
				>
					×
				</TemperatureClose>
				<LevelUpHero $color={celebratedColor}>
					<FlameIcon lit size="hero" color={celebratedColor} />
				</LevelUpHero>
				<LevelUpMinis aria-hidden="true">
					{flameLevels.map((level, index) => (
						<FlameIcon
							key={`mini-${level.id}`}
							lit={index < celebratedLitCount}
							size="sm"
							color={getLevelColor(level, celebratedColor)}
						/>
					))}
				</LevelUpMinis>
				<LevelUpTitle id="levelup-title">{t.levelUpTitle}</LevelUpTitle>
				<LevelUpEyebrow>{t.newLevelEyebrow}</LevelUpEyebrow>
				<LevelUpName $color={celebratedColor}>{celebratedLevel.name}</LevelUpName>
				<LevelUpBlurb>
					{celebratedLevel.description || levelDescription}
				</LevelUpBlurb>
				<LevelUpCta type="button" onClick={onClose} $color={celebratedColor}>
					{t.continueConversation}
				</LevelUpCta>
				<LevelUpFooter>
					{(t.levelOfMax || 'Poziom {current} z {max}')
						.replace('{current}', String(celebratedLitCount))
						.replace('{max}', String(flameCount))}
				</LevelUpFooter>
			</LevelUpModal>
		</TemperatureBackdrop>,
		document.body,
	);

export default LevelUpDialog;
